<template>
  <mui-popover
    class="verification-stamp-popover"
    @update:open="isPopoverOpen = $event"
    :is-open="isPopoverOpen"
    :has-close-button="true"
  >
    <verification-stamp
      @userVerificationStatus="userStatus = $event"
    ></verification-stamp>

    <template #content>

      <div class="verification-stamp-popover__content">

        <svg class="verification-stamp-popover__icon">
          <use :xlink:href="getModalConfig('ICON')"></use>
        </svg>

        <h2 class="verification-stamp-popover__title">
          {{getModalConfig('TITLE')}}
        </h2>

        <p class="verification-stamp-popover__text">
          {{getModalConfig('BODY')}}
        </p>

        <div class="verification-stamp-popover__footer">
          <button
            class="mui-button mui-button--primary"
            @click.prevent="redirectToLink()"
          >
            {{getModalConfig('BUTTON')}}
          </button>
        </div>
      </div>

    </template>
  </mui-popover>
</template>

<script>

import MuiPopover from 'commons/js/components/atoms/MuiPopover'
import VerificationStamp from 'commons/js/components/atoms/VerificationStamp'
import verificationStamp from 'commons/js/mixins/verificationStamp';

export default {
  name: 'verification-stamp-popover',

  components: {
    MuiPopover,
    VerificationStamp
  },

  mixins: [verificationStamp],

  data() {
    return {isPopoverOpen: false};
  },

	methods: {

    /**
     * Closes the popover externally
     */
    closePopover() {
      this.isPopoverOpen = false;
    }
  }
}
</script>

<style lang="stylus" scoped>

.verification-stamp-popover
  &__content
    max-width 320px
    display flex
    flex-direction column
    justify-content center
    align-items center

  &__icon
    margin-top 16px
    margin-bottom 16px
    width 40px
    height 40px

  &__title
    font-weight bold
    margin-bottom 8px

  &__text
    margin 0 12px 14px
    text-align center
    font-size 14px

  &__footer
    margin-bottom 16px

</style>
